// 用户信息
const userInfo = {
  logoutUrl: '', // 退出
  menus: [], // 菜单树
  user: {} // 用户信息
};
// 分位时长
const quantileTimeList = [];

export {
  userInfo,
  quantileTimeList
}
